import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Sheikh_Khalifa_Hospital.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Sheikh Khalifa Specialty Hospital — RAK</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>A government-operated specialist hospital in Ras Al Khaimah providing advanced healthcare services to the emirate's
                residents. Operated under the Sheikh Khalifa Specialty Hospital brand, the facility is a key pillar of RAK's public healthcare
                infrastructure.</p>
              <p>MAIN CONTRACTOR : -</p>
              <p>MEP CONTRACTOR : ETA</p>
              <p>GEMCO SCOPE OF WORKS : MEP works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one